<template>
  <div class="acceptance-form">
    <tg-title>Tudo certo por aqui! </tg-title>
    <tg-text
      >Agradecemos por aceitar as mudanças. Sua experiência no RD Conversas
      continua como sempre, agora com os novos termos em vigor.</tg-text
    >
    <div class="acceptance-actions">
      <tg-button type="button" :loading="loading" @click="accept"
        >Voltar para RD Conversas</tg-button
      >
    </div>
  </div>
</template>
<script>
import NewAcceptanceStatusMixin from "@/mixins/NewAcceptanceStatusMixin";
import TangramTitle from "@/components/Tangram/Title.vue";
import TangramText from "@/components/Tangram/Text.vue";
import TangramButton from "@/components/Tangram/Button.vue";

export default {
  name: "NewAcceptTermSuccess",

  mixins: [NewAcceptanceStatusMixin],

  components: {
    "tg-title": TangramTitle,
    "tg-text": TangramText,
    "tg-button": TangramButton,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  methods: {
    accept() {
      this.$emit("accepted", this.acceptanceSteps.SUCCESS);
    },
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@400;600&display=swap");

:root {
  font-family: "Red Hat Display", sans-serif;
}

.company-name {
  color: #11a7b6;
}

.acceptance-form {
  width: 100%;
  height: auto;
  gap: 24px 0;
  padding-left: 72px;
  display: flex;
  flex-direction: column;
}
</style>
